/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_Cy_ScopeInputs */

const es_marketplace_seo_license_row_cy_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Cy_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación de recreo sin límite de distancia.`)
};

const gl_marketplace_seo_license_row_cy_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Cy_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación de recreo sen límite de distancia.`)
};

const en_marketplace_seo_license_row_cy_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Cy_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited recreational navigation.`)
};

/**
* | output |
* | --- |
* | "Unlimited recreational navigation." |
*
* @param {Marketplace_Seo_License_Row_Cy_ScopeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_cy_scope = /** @type {((inputs?: Marketplace_Seo_License_Row_Cy_ScopeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_Cy_ScopeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_cy_scope(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_cy_scope(inputs)
	return es_marketplace_seo_license_row_cy_scope(inputs)
});